/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CategorySalesfor1997ListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: CategorySalesfor1997Service
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, HostBinding, EventEmitter, Input, Output, OnInit, ViewChild,
	trigger, transition, animate,
	style, state } from '@angular/core';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastsManager }  from 'ng2-toastr';
import myGlobals = require('../globals');

import { CategorySalesfor1997Data, CategorySalesfor1997Service } from './CategorySalesfor1997.service';
import { CategorySalesfor1997SearchComponent }  from './CategorySalesfor1997Search.component';

@Component({
	selector: 'my-CategorySalesfor1997',
	template: require('./CategorySalesfor1997List.component.html'),
	providers: [CategorySalesfor1997Service],
	animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.4s ease-in')
      ]),
      transition(':leave', [
        animate('0.7s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class CategorySalesfor1997ListComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}
	
	CategorySalesfor1997List: CategorySalesfor1997Data[];
	newCategorySalesfor1997: CategorySalesfor1997Data;
	selectedCategorySalesfor1997: CategorySalesfor1997Data;
	errorMessage: string;
	messages: string[];
	showAdd: boolean;
	@ViewChild(CategorySalesfor1997SearchComponent) filterComponent: CategorySalesfor1997SearchComponent;

	sortExpression: string = "CategoryName";
	filterExpression: string = "";
	pageIndex: number = 1;
	pageSize: number = 10;
	endRowIndex: number;
	rowsCount: number;
	pageCount: number;
	isFirstPage: boolean;

    private selectedId: string;

	constructor(
		private CategorySalesfor1997Service: CategorySalesfor1997Service,
		private route: ActivatedRoute,
		private router: Router,
		private toastr: ToastsManager
	) {
		this.newCategorySalesfor1997 = new CategorySalesfor1997Data();
		this.pageSize = myGlobals.pageSize;
	}

	ngOnInit() {
		// this.CategorySalesfor1997Service.getAll().subscribe(record => this.CategorySalesfor1997List=record);
		this.pageIndex = 1;
		this.isFirstPage = true;
		this.getCategorySalesfor1997ByPaging();

		/*
		this.CategorySalesfor1997List = this.route.params
			.switchMap((params: Params) => {
				this.selectedId = +params['id'];
				return this.service.getAll();
			});
		*/
	}

	// Get all records
	public getCategorySalesfor1997() {
		this.CategorySalesfor1997Service.getAll()
			.subscribe(data => this.CategorySalesfor1997List = data,
		error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error);
	}
	
	// On Search CLick on CategorySalesfor1997Search Component
	onSearch(searchText: string) {
		// 1. Update this.filterExpression
		this.filterExpression = searchText;

		// 2. call getCategorySalesfor1997ByPaging method that will refresh the data
		this.pageIndex = 1;
		this.getCategorySalesfor1997ByPaging();
	}
	
	onSort(event, sortColumn: string)
	{
		// var target = event.target || event.srcElement || event.currentTarget;
		// var parent = target.parentNode;
		if (this.sortExpression === sortColumn)
			this.sortExpression = sortColumn + ' desc';
		else if (this.sortExpression === sortColumn + ' desc')
			this.sortExpression = sortColumn;
		else
			this.sortExpression = sortColumn;
		this.getCategorySalesfor1997ByPaging();
	}
	
	// Get records by paging
	getCategorySalesfor1997ByPaging() {
		this.CategorySalesfor1997Service.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
			.subscribe(data => {
				this.CategorySalesfor1997List=data.CategorySalesfor1997List;
				this.rowsCount=data.RowsCount; 
				this.pageCount= Math.ceil(this.rowsCount / this.pageSize);
				if (this.pageIndex == 1)
					this.isFirstPage = true;
				else
					this.isFirstPage = false;
				if (this.pageIndex == this.pageCount)
					this.endRowIndex = this.rowsCount;
				else
					this.endRowIndex = this.pageIndex * this.pageSize;
			},
			error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error
		);
	}
	// Adds new record
	addCategorySalesfor1997() {
		this.CategorySalesfor1997Service.addCategorySalesfor1997Data(this.newCategorySalesfor1997).subscribe(record => console.log(record));
		this.getCategorySalesfor1997();
	}
  
	// Updates existing record
	updateCategorySalesfor1997() {
		this.CategorySalesfor1997Service.updateCategorySalesfor1997Data(this.selectedCategorySalesfor1997).subscribe(record => console.log(record));
		this.getCategorySalesfor1997();
	}

	// Deletes record with specified id
	deleteCategorySalesfor1997(id: string) {
		if (window.confirm('Are you sure you want to delete this CategorySalesfor1997?') == true)
		{
			this.CategorySalesfor1997Service.deleteCategorySalesfor1997(id)
			.subscribe(data => this.getCategorySalesfor1997(), 
			error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error);
		}
	}

	// Go to First Page
	onFirstPage() {
		this.pageIndex = 1;
		this.getCategorySalesfor1997ByPaging();
	}

	// Go to Previous Page
	onPreviousPage() {
		if (this.pageIndex > 1) {
			this.pageIndex = this.pageIndex - 1;
			this.getCategorySalesfor1997ByPaging();
		}
	}

	// Go to Next Page
	onNextPage() {
		if (this.pageIndex < this.pageCount) {
			this.pageIndex = this.pageIndex + 1;
			this.getCategorySalesfor1997ByPaging();
		}
	}

	// Go to Last Page
	onLastPage() {
		this.pageIndex = this.pageCount;
		this.getCategorySalesfor1997ByPaging();
	}

	// Refresh - Go to First Page
	onRefresh() {
		this.onFirstPage();
	}

	// On Edit - Go to Edit page
	onSelect(item: CategorySalesfor1997Data) {
		this.router.navigate(['/CategorySalesfor1997', item.CategoryName]);
	}

	// On Details - Go to Details page
	onSelectDetails(item: CategorySalesfor1997Data) {
		this.router.navigate(['/CategorySalesfor1997/Details', item.CategoryName]);
	}

	// Set record as selected
	SelectCategorySalesfor1997(item: CategorySalesfor1997Data) {
		this.selectedCategorySalesfor1997 = item;
	}

	// Submits form
	submitForm(data: Object) {
		console.log(data);
	}

	// Logs message onto Console
	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}

/*
	isSelected(item: CategorySalesfor1997Data) {
		return item.CategoryName === this.selectedId;
	}
*/
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/CategorySalesfor1997/CategorySalesfor1997List.component.ts